import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// jl-design-system
import { PrimaryButton, SecondaryButton } from 'jl-design-system/elements/button/Button';
import { SecondaryLink } from 'jl-design-system/elements/link/Link';
import LoadingSpinner from 'jl-design-system/components/loading-spinner/LoadingSpinner';
// constants
import editBasketConstants from '../../constants/editBasketConstants';
import urlConstants from '../../constants/urlConstants';
// styles
import styles from './edit-basket-item-overlay.scss';


class EditBasketItemOverlay extends PureComponent {

  static propTypes = {
    disabled: PropTypes.bool,
    hasChildItems: PropTypes.bool,
    lastItemInBasket: PropTypes.bool,
    onRemoveNo: PropTypes.func,
    onRemoveYes: PropTypes.func,
    removeItemApiCallActive: PropTypes.bool,
    type: PropTypes.oneOf([
      editBasketConstants.REMOVE_ITEM,
      editBasketConstants.OUT_OF_STOCK_ITEM,
      editBasketConstants.REMOVE_TRADE_IN_ITEM,
    ]),
  };

  static defaultProps = {
    disabled: false,
    hasChildItems: false,
    lastItemInBasket: false,
    onRemoveNo: window.defaultFunc,
    onRemoveYes: window.defaultFunc,
    removeItemApiCallActive: false,
    type: editBasketConstants.REMOVE_ITEM,
  };

  render() {
    const {
      type,
      lastItemInBasket,
      disabled,
      removeItemApiCallActive,
      onRemoveYes,
      onRemoveNo,
      hasChildItems,
    } = this.props;

    const itemContainerClassnames = classNames(styles.itemContainer, {
      [styles.itemWithChildrenContainer]: hasChildItems,
    });

    return (
      <div className={itemContainerClassnames}>
        {
          removeItemApiCallActive && <LoadingSpinner data-test="edit-basket-item-remove-spinner" />
        }
        {
          !removeItemApiCallActive &&
          <React.Fragment>

            {
              (type === editBasketConstants.REMOVE_ITEM ||
              type === editBasketConstants.REMOVE_TRADE_IN_ITEM) &&
                <div data-test="edit-basket-item-remove">
                  <p data-test="edit-basket-item-remove-title">Are you sure you want to remove this item?</p>

                  <div className={styles.ctaWrapper}>
                    <SecondaryButton
                      className={styles.removeItemChoiceButton}
                      data-test="edit-basket-item-remove-button-yes"
                      disabled={disabled}
                      onClick={onRemoveYes}
                    >
                      Yes
                    </SecondaryButton>

                    <SecondaryButton
                      className={styles.removeItemChoiceButton}
                      data-test="edit-basket-item-remove-button-no"
                      disabled={disabled}
                      onClick={onRemoveNo}
                    >
                      No
                    </SecondaryButton>
                  </div>

                  {
                    lastItemInBasket &&
                    <p
                      className={styles.confirmRemoveLastItem}
                      data-test="edit-basket-item-remove-last-item"
                    >
                      This will redirect you to the homepage as your basket will be empty.
                    </p>
                  }
                </div>
            }
            {
              (type === editBasketConstants.OUT_OF_STOCK_ITEM) &&
              <div data-test="edit-basket-item-out-of-stock">
                <p data-test="edit-basket-item-out-of-stock-title">Sorry, this item is no longer available. Please remove this item to continue.</p>

                <div className={styles.ctaWrapper}>
                  <PrimaryButton
                    className={styles.outOfStockChoiceButton}
                    data-test="edit-basket-item-out-of-stock-remove"
                    disabled={disabled}
                    onClick={onRemoveYes}
                  >
                    Remove
                  </PrimaryButton>

                  <SecondaryLink
                    className={styles.outOfStockChoiceButton}
                    data-action="handback"
                    data-test="edit-basket-item-out-of-stock-return-to-basket"
                    disabled={disabled}
                    to={urlConstants.BASKET_PAGE_URL}
                  >
                    Return to basket
                  </SecondaryLink>
                </div>

                {
                  lastItemInBasket &&
                  <p
                    className={styles.confirmRemoveLastItem}
                    data-test="edit-basket-item-remove-last-item"
                  >
                    This will redirect you to the homepage as your basket will be empty.
                  </p>
                }
              </div>
            }

          </React.Fragment>
        }

      </div>
    );
  }
}

export default EditBasketItemOverlay;
